<div class="modal-header">
  <h5 class="modal-title">Senha de liberação</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
  <h4 style="text-align: center;">
    <svg cIcon size="xl" name="cidLockLocked"></svg>
    Senha
  </h4>
  <form [formGroup]="form" (ngSubmit)="accept()">   
    <div class="row mb-2">
      <div class="col-12">
        <input id="password" type="password" formControlName="password" class="form-control"
            [ngClass]="{'is-invalid': errorMessage(password) !== null}" />
        <div *ngIf="errorMessage(password) !== null" class="invalid-feedback">
            {{ errorMessage(password) }}
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button cButton color="danger" (click)="decline()">
    <svg cIcon name="cilX"></svg>
    Cancelar
  </button>
  <button cButton color="primary" (click)="accept()">
    <svg cIcon name="cilCheckAlt"></svg>
    Enviar
  </button>
</div>